export const FEEDBACK_TYPES = {
  GENERAL: 'General Feedback',
  FEATURE: 'Feature Request',
  ISSUE: 'Issue',
}

export const FEEDBACK_TYPE_OPTIONS = [
  FEEDBACK_TYPES.GENERAL,
  FEEDBACK_TYPES.FEATURE,
  FEEDBACK_TYPES.ISSUE,
]
